export default __webpack_public_path__ + "static/media/Hero_images.7f4f9592.png";